import { Fragment } from "react";
import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { useApplicationContext } from "./ApplicationContext";
import { AuthRedirector } from "./AuthRedirector";
import { MainRedirector } from "./MainRedirector";
import { AuthLayout } from "./AuthLayout";
import { MainLayout } from "./MainLayout";
import { NotFound } from "./NotFound";
import frames from "frames";
import { FiltersContextWrapper } from "components/FiltersContext";

import "styles/theme.less";

export const Application: React.FC<{}> = () => {
  const applicationContext = useApplicationContext();
  const location = useLocation();
  const { i18n } = useTranslation();

  const helmet = (
    <Helmet>
      <html lang={i18n.language} />
      <meta charSet="utf-8" />
      <link rel="icon" type="image/png" href="/favicon.png" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <title>Pgn Showroom</title>
      <body />
    </Helmet>
  );

  let application = <Fragment></Fragment>;

  if (!applicationContext.authenticated) {
    console.info("Not authenticated!");

    application = (
      <Routes>
        <Route path="/" element={<AuthRedirector />} />
        <Route element={<AuthLayout />}>
          <Route path="/auth/sign-in" element={<frames.AuthSignIn />} />
          <Route path="/auth/password-reset/:token" element={<frames.AuthCompletePasswordReset />} />
          <Route path="/auth/password-reset" element={<frames.AuthRequestPasswordReset />} />
        </Route>
        <Route path="*" element={<AuthRedirector />} />
      </Routes>
    );
  } else if (location.state && (location.state as any).landingUrl) {
    application = <Navigate to={(location.state as any).landingUrl} replace />;
  } else if (applicationContext.session.currentUser.role === "USER") {
    application = (
      <FiltersContextWrapper>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<frames.BrandsList />} />
            <Route path="/b/:brandId/s/:seasonId" element={<frames.SeasonsShow />} />
            <Route path="/b/:brandId/s/:seasonId/l/:lineId" element={<frames.LinesShow />} />
            <Route path="/b/:brandId/s/:seasonId/i/:itemId" element={<frames.ItemsShow />} />
            <Route path="/b/:brandId/pk" element={<frames.BrandsPressKit />} />
            <Route path="/cart" element={<frames.OrdersCart />} />
            <Route path="/orders" element={<frames.OrdersList />} />
            <Route path="/cart/confirmed" element={<frames.OrdersCartConfirmed />} />
            <Route path="/profile" element={<frames.AccountsProfile />} />
          </Route>
          <Route path="/auth/*" element={<MainRedirector />} />
          <Route path="/global/*" element={<MainRedirector />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </FiltersContextWrapper>
    );
  } else {
    window.location.assign(applicationContext.siteEnvironment.appEndpointOffice);
  }

  return (
    <Fragment>
      {helmet}
      {application}
    </Fragment>
  );
};
